/*
 * @Author: xuejian3721
 * @Date: 2021-07-08 09:46:23
 * @LastEditors: xuejian3721
 * @LastEditTime: 2024-12-12 12:14:27
 */
import headservice from '@/assets/image/headservice.png'
import tripartite from '@/assets/image/tripartite.png'
import userAvatarSaas from '@/assets/image/avatar-user-saas.png'
import grouphead from '@/assets/image/grouphead.png'

export default {
  jzt: {
    title: '',
    type: 'red',
    userAvatar: userAvatarSaas,
    agentAvatar: headservice
  },
  yjj: {
    title: '',
    type: 'red',
    userAvatar: userAvatarSaas,
    agentAvatar: tripartite
  },
  blue: {
    title: '',
    type: 'blue',
    userAvatar: userAvatarSaas,
    agentAvatar: grouphead
  }
}
